import httpRequest from "../utils/axios.js";
import config from "./config.js";

export function withdrawApi(data) {
  var url = config.withdraw;
  return httpRequest.fetchPost(url, data);
}

export function getWithdrawInfoApi(couponNum) {
  const url = config.fetchWithdrawInfo;
  return httpRequest.fetchGet(url, { couponNum });
}

//查询今日剩余可提现额度
export function getQuickWithdrawQuotaApi(params) {
  var url = '/api/v1.0/wechat/user/remaining/quickWithdrawQuota';
  return httpRequest.fetchGet(url, params);
}